import React, { useEffect, useState, useContext } from "react"
import axios from "axios"
import { useBeforeunload , Beforeunload} from "react-beforeunload"
import * as channelJson from "../../../static/channel.json"
import { Link, navigate, withPrefix } from "gatsby"
import Header from "../Header"
import Footer from "../Footer"
import JourneyOne from "../journey/journey-1"
import Disclaimers from "../disclaimers"
import CPchooseplan from "../cp-chooseplan"
import Ekyc from "../sections/ekyc/ekyc"
import { JourneyContext } from "../context/journeyContext"
import { decryptUrl, saveDropoutTimeStamp, getIpAddress, getJWTTokenForIp, channelJourneyCheck, getConfigurationsByType, verifyAgencyAcessToken, getSpDetailsFromRandomId, refreshAgencyAccessToken } from "../../services/apiservice"
import { findCurrentJourneyCode, getKeyFromValueLookup } from "../services/helperFunctions"
import Rmled from "../../pages/rmled"
import base64 from 'base-64'
import * as lookup from "../../../static/lookup.json"
import { errorToastr } from "../../services/error-handler"
import { refreshToken } from "../../interceptors/jwt-interceptor"
import OfflineNotice from "../common/OfflineNotice"
import { AgencyContext } from "../context/agencyContext"
import { clearAllCookies } from "../../shared/functions"
var CryptoJS = require("crypto-js");
const Layout = props => {
  // console.log("layout props",props)
  const [channel, setchannel] = useState("")
  const [channelProperty, setChannelProperty] = useState({})
  const [decryptData, setDecryptData] = useState()
  const [isRedirected, setIsRedirected] = useState(false)
  const [isNavigateToRM, setIsNavigateToRM] = useState(false)
  const [journeyId, setJourneyId] = useState()
  const [rmData,setRmData] = useState({})
  const channelList = channelJson.data.channels
  const [allChannel, setAllChannel] = useState(false);

  const [journeyState, setJourneyState] = useContext(JourneyContext);
  const {setAgencyState} = useContext(AgencyContext);

  useEffect(() => {
    (async () => {
      if (props.paymentData && props.paymentData.decryptData && props.paymentData.payloadJson) {
        try {
          if ((["A", "B", "C", "D","30", "33"].includes(props.paymentData.payloadJson.source))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.paymentData.payloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if ((["hsbc", "canara", "pnb", "others", "equitas", "36"].includes(props?.paymentData?.payloadJson?.source?.toLowerCase()))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == props.paymentData.payloadJson.source?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if(["website","pbp"].includes(props?.paymentData?.payloadJson?.source?.toLowerCase())) {
              setchannel( props?.paymentData?.payloadJson?.source?.toUpperCase());
              setChannelProperty(channelList[3]);
              channelTheme();
              setIsRedirected(false);
              setIsNavigateToRM(false);
          } else{
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.paymentData.payloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId)
                setChannelProperty(element)
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }
        }
        catch(e)
        {
          console.log("asdasd",e)
        }
      }else if (props.enachData && props.enachData.enachDecryptData && props.enachData.enachPayloadJson) {
        try {
          if ((["A", "B", "C", "D","30", "33"].includes(props.enachData.enachPayloadJson.source))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.enachData.enachPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if ((["hsbc", "canara", "pnb", "others", "equitas"].includes(props?.paymentData?.payloadJson?.source?.toLowerCase()))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == props.enachData.enachPayloadJson.source?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if(["website","pbp"].includes(props?.enachData?.enachPayloadJson.source?.toLowerCase())) {
              setchannel( props?.enachData?.enachPayloadJson?.source?.source?.toUpperCase());
              setChannelProperty(channelList[3]);
              channelTheme();
              setIsRedirected(false);
              setIsNavigateToRM(false);
          } else{
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.enachData.enachPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId)
                setChannelProperty(element)
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }
        }
        catch(e)
        {
          console.log("asdasd",e)
        }
      }else if (props.lienData && props.lienData.lienDecryptData && props.lienData.lienPayloadJson) {
        try {
          if ((["A", "B", "C", "D","30", "33"].includes(props.lienData.lienPayloadJson.source))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.lienData.lienPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if ((["hsbc", "canara", "pnb", "others", "equitas", "36"].includes(props?.paymentData?.payloadJson?.source?.toLowerCase()))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == props.lienData.lienPayloadJson.source?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }else if(["website","pbp"].includes(props?.lienData?.lienPayloadJson?.source?.toLowerCase())) {
              setchannel( props?.lienData?.lienPayloadJson?.source?.toUpperCase());
              setChannelProperty(channelList[3]);
              channelTheme();
              setIsRedirected(false);
              setIsNavigateToRM(false);
          } else{
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.lienData.lienPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId)
                setChannelProperty(element)
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }
        }
        catch(e)
        {
          console.log("asdasd",e)
        }
      }else if (props.digilockerdata && props.digilockerdata.digilockerDecryptData && props.digilockerdata.digilockerPayloadJson) {
        try {
          if ((["A", "B", "C", "D","30", "33", "36"].includes(props.digilockerdata.digilockerPayloadJson.source))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.digilockerdata.digilockerPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if ((["hsbc", "canara", "pnb", "others"].includes(props?.paymentData?.payloadJson?.source?.toLowerCase()))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == props.digilockerdata.digilockerPayloadJson.source?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }else if(["website","pbp"].includes(props?.digilockerdata?.digilockerPayloadJson?.source?.toLowerCase())) {
              setchannel( props.digilockerdata.digilockerPayloadJson.source?.toUpperCase());
              setChannelProperty(channelList[3]);
              channelTheme();
              setIsRedirected(false);
              setIsNavigateToRM(false);
          }else{
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.digilockerdata.digilockerPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId)
                setChannelProperty(element)
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }
        }
        catch(e)
        {
          console.log("asdasd",e)
        }
      }
      else if (props.location.search) {
        const urlParams = new URLSearchParams(props.location.search)
        if (urlParams) {
          setIsRedirected(true);
          queryFunction(urlParams);
        }
      } else if(props.resumeJourneyData){
        if(props.resumeJourneyData.applicationData?.journeyData?.basicDetails?.channel){
          let fetchedChannel;
          if(!(["A","B","C","D", "33", "36"].includes(props.resumeJourneyData.applicationData?.journeyData?.basicDetails?.channel))){
            fetchedChannel = props.resumeJourneyData.applicationData?.journeyData?.basicDetails?.channel;
            setchannel(fetchedChannel);
            setChannelProperty(channelList[3]);
            channelTheme();
            setIsRedirected(false);
            setIsNavigateToRM(false);
            // setIsPaymentData(true);
          }else{
            fetchedChannel = getKeyFromValueLookup("reverseChannelType", props.resumeJourneyData.applicationData?.journeyData?.basicDetails?.channel);
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == fetchedChannel?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element)
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
                // setIsPaymentData(true);
              }
            })
          }
        }
        if(props?.resumeJourneyData?.journeyData?.paymentFrequency){
          setJourneyState(prev => {
          return({
            ...prev,
            paymentFrequency: props?.resumeJourneyData?.journeyData?.paymentFrequency
          })
        })
        }
      }else if(props.fnaData){
        
        setchannel(props.fnaData?.fnaData?.source?.toUpperCase() || "");
        setChannelProperty(channelList.find(element => element.channelId.toUpperCase() == props.fnaData?.fnaData?.source?.toUpperCase()) || channelList[3]);
        channelTheme()
        setIsRedirected(false)
        setIsNavigateToRM(false)
      }
      else if(props.canaraPosData){
        setchannel("C")
        setChannelProperty(channelList[1])
        channelTheme()
        setIsRedirected(false)
        setIsNavigateToRM(false)
      }else {
        navigate("/invalidChannel")
        // if (!channel) {
        //   setchannel("others")
        //   setAllChannel(true)
        //   // setIsNavigateToRM(true);
        // }
        // // without query Params
        // channelList.forEach(element => {
        //   if (element.channelId == "others") {
        //     setchannel(element.channelId)
        //     setChannelProperty(element)
        //   }
        // })
        // channelTheme()
      }
    })()
  
  }, [channel,props])

  async function checkIsLoggedIn() {
    try{
      // First check if rid is present in query parameters
      let randomId = null;
      if (typeof window !== "undefined" && props.location?.search) {
        const urlParams = new URLSearchParams(props.location.search);
        const ridFromQuery = urlParams.get('rid');
        if (ridFromQuery) {
          randomId = ridFromQuery;
          // Explicitly set x-rid in session storage when using query param
          sessionStorage.setItem('x-rid', ridFromQuery);
        }
      }
      
      // If not in query params, use session storage
      if (!randomId) {
        randomId = sessionStorage.getItem('x-rid');
      }
      
      sessionStorage.removeItem("accessToken")
      if (randomId){
        let spDetails = null;
        try{
          spDetails = await getSpDetailsFromRandomId({ randomId: randomId });
        }catch(error){
          sessionStorage.removeItem('x-rid');
          errorToastr("Login failed. Please try again, redirecting to login page")
          setTimeout(() => {
            window.location.href = process.env.AGENCY_LOGIN_URL
          }, 3000)
        }
          
        if (spDetails){
          const accessToken = spDetails?.data?.accessToken;
          const refreshToken = spDetails?.data?.refreshToken;
          if (accessToken && refreshToken){
          // Validate the accessToken by calling apiService verifyAgencyAcessToken
            try {
              const response = await verifyAgencyAcessToken({ accessToken });
              // If API returns valid/true, consider as logged in
              if (response && response.data && response.status === true) {
                setAgencyState(prev => {
                  return({
                    ...prev,
                    accessToken: accessToken,
                    refreshToken: refreshToken,
                    spCode: spDetails?.data?.spCode,
                    spPh: spDetails?.data?.mobileNo,
                    spMail: spDetails?.data?.email,
                    spDesignation: spDetails?.data?.designation,
                    spAgentName: spDetails?.data?.fullName,
                    branchId:spDetails?.data?.branchId,
                    supervisorName: spDetails?.data?.supervisor?.name,
                    supervisorMobile: spDetails?.data?.supervisor?.mobile,
                    supervisorDesignation: spDetails?.data?.supervisor?.designation,
                    supervisorEmpCode: spDetails?.data?.supervisor?.empCode,
                  })
                })
                return true;
              }else{
                const refreshResponse = await refreshAgencyAccessToken({ refreshToken })
                if (refreshResponse && refreshResponse.data && refreshResponse.status) {
                  setAgencyState(prev => {
                    return({
                      ...prev,
                      accessToken: accessToken,
                      refreshToken: refreshToken,
                      spCode: spDetails?.data?.spCode,
                      spPh: spDetails?.data?.mobileNo,
                      spMail: spDetails?.data?.email,
                      spDesignation: spDetails?.data?.designation,
                      spAgentName: spDetails?.data?.fullName,
                      branchId:spDetails?.data?.branchId,
                      supervisorName: spDetails?.data?.supervisor?.name,
                      supervisorMobile: spDetails?.data?.supervisor?.mobile,
                      supervisorDesignation: spDetails?.data?.supervisor?.designation,
                      supervisorEmpCode: spDetails?.data?.supervisor?.empCode,
                    })
                  })
                  return true;
                }else{
                  return false;
                }
              }
            } catch (err) {
              sessionStorage.removeItem('x-rid');
              errorToastr("Login failed. Please try again, redirecting to login page")
              setTimeout(() => {
                window.location.href = process.env.AGENCY_LOGIN_URL
              }, 3000)
            }
          }
          return false;
        }
      }else{
        return false;
      }
    }catch(err){
      return false;
    }
  }

  useEffect(() => {
    const journeyIdFromStrapi = journeyState.journeyIdFromStrapi;
    const source = getSource(props);

    const runAll = async () => {
      if (!journeyIdFromStrapi) {
        console.info('Channel or journey ID is missing.');
        return;
      }

      // Determine whether the login flow applies for this session
      let shouldCheckLogin = false;
      try {
        const isLoginFlowApplicable =
          !props.resumeJourneyData &&
          !props.paymentData &&
          !props.digilockerdata &&
          !props.enachData &&
          !props.lienData &&
          !props.canaraPosData;

        if (isLoginFlowApplicable) {
          const loginJourney = await getConfigurationsByType({ type: "login-config" });
          const loginProductAllowed = loginJourney?.data?.[0]?.config?.products[journeyIdFromStrapi];
          if (loginProductAllowed?.channels && loginProductAllowed.channels?.length > 0) {
            const loginChannelAllowed = loginProductAllowed?.channels?.includes(source?.toUpperCase());
            if (loginChannelAllowed) {
              setJourneyState(prev => ({ ...prev, loginJourney: "Y" }));
              shouldCheckLogin = true;
            }
          }
        }
      } catch (error) {
        console.info("error in checking login-config", error);
      }

      // 🚀 Fire blacklisted-countries, channelJourneyCheck, and (if applicable)
      //    checkIsLoggedIn all in parallel
      const parallelCalls = [
        getConfigurationsByType({ type: "blacklisted-countries" }),
        channelJourneyCheck(
          source || "",
          journeyIdFromStrapi,
          props?.resumeJourneyData?.journeyData
        ),
        ...(shouldCheckLogin ? [checkIsLoggedIn()] : []),
      ];

      const results = await Promise.allSettled(parallelCalls);
      const [blacklistRes, journeyRes, loginRes] = results;

      // ✅ Handle journey check
      if (journeyRes.status === "fulfilled") {
        if (!journeyRes.value?.valid) {
          navigate("/ProductNotAvailablePage");
        }
      } else {
        console.info("channelJourneyCheck failed", journeyRes.reason);
        navigate("/ProductNotAvailablePage");
      }

      // ✅ Handle login check (only populated when shouldCheckLogin was true)
      if (shouldCheckLogin) {
        if (loginRes.status === "fulfilled") {
          if (!loginRes.value) {
            window.location.href = process.env.AGENCY_LOGIN_URL;
          }
          // fna redirection removed now
        } else {
          console.info("checkIsLoggedIn failed", loginRes.reason);
          window.location.href = process.env.AGENCY_LOGIN_URL;
        }
      }

      // ✅ Handle blacklist separately
      if (blacklistRes.status === "fulfilled") {
        const res = blacklistRes.value;

        if (res?.data && res?.data?.[0]?.config) {
          const blacklist = res?.data?.[0].config;
          const blacklistedCodes = Object.keys(blacklist);

          const countryKeyLookups = [
            "country",
            "countryWithoutIndia",
            "countryCodeToCountry",
            "countryRegex",
            "countryToCountryCode",
          ];

          if (
            lookup.countryToCountryCode?.[0] &&
            lookup.phoneCountryCodes?.[0]
          ) {
            blacklistedCodes.forEach((code) => {
              const phoneCode = lookup.countryToCountryCode[0][code];
              if (phoneCode) {
                delete lookup.phoneCountryCodes[0][phoneCode];
              }
            });
          }
          countryKeyLookups.forEach((key) => {
            if (lookup[key]?.[0]) {
              blacklistedCodes.forEach((code) => {
                delete lookup[key][0][code];
              });
            }
          });
        }
      } else {
        console.info("blacklisted-countries failed", blacklistRes.reason);
      }
    };

    runAll();
  }, [channel, props.resumeJourneyData?.journeyData]);

const getSource = (props) => {
  if(props?.location?.search){
    const urlParams = new URLSearchParams(props.location.search);
    const source = urlParams.get("source");
    return source.toLowerCase();
  }
  if(journeyState.channel){
    const channelA = journeyState.channel;
    let channelsearchA = lookup.MediaPartnerCode.find(element => element.ISNP_CHANNEL_TYPE.toLowerCase() === channelA?.toLowerCase())
    const sourceA = channelsearchA?.ITEM_CODE.toLowerCase();
    return sourceA;
  }
  if(props.resumeJourneyData){
    const channelB = props.resumeJourneyData.journeyData.basicDetails.channel
    let channelsearchB = lookup.MediaPartnerCode.find(element => element.ISNP_CHANNEL_TYPE.toLowerCase() === channelB?.toLowerCase())
    const sourceB = channelsearchB?.ITEM_CODE.toLowerCase();
    return sourceB;
  }
  if(props.paymentData){
    let channelC = props.paymentData.payloadJson.source
    if (channelC.length > 1){
      return props.paymentData.payloadJson.source.toLowerCase()
    }else{
      let channelsearchC = lookup.MediaPartnerCode.find(element => element.ISNP_CHANNEL_TYPE.toLowerCase() === channelC?.toLowerCase())
      const sourceC = channelsearchC?.ITEM_CODE.toLowerCase();
      return sourceC;
    }
  }
  if (props.fnaData){
    return props.fnaData.fnaData.source.toUpperCase();
  }
}
  
  async function queryFunction(urlParams) {
    const parameter1 = urlParams.get("data")
    const parameter2 = urlParams.get("source")?.toUpperCase();
    const parameter3 = urlParams.get("journeyId")
    const parameter4 = urlParams.get("CSIDPROC")?.toUpperCase();
    setJourneyId(parameter3);
    if(parameter4 &&  parameter4.toUpperCase() === "Y"){
      setJourneyState(prev => {
        return ({
          ...prev,
          corpDiscOpt: "Y"
        })
      })
    }else if((parameter4 && parameter4.toUpperCase() != "Y")){
      navigate("/invalidChannel")
    }
    else{
      setJourneyState(prev => {
        return ({
          ...prev,
          corpDiscOpt: "N"
        })
      })
    }
    if(["HSBC","CANARA","OTHERS","EQUITAS"].includes(parameter2?.toUpperCase())){
      channelList.forEach(element => {
        if (element.channelId.toUpperCase() == parameter2) {
          setchannel(element.channelId);
          setChannelProperty(element);
          setAllChannel(true);
        }
      })
    }
    else{
      let paramenterInMediaPartner = lookup.MediaPartnerCode.findIndex(element => element.ITEM_CODE === parameter2)
      if(paramenterInMediaPartner !== -1){
        setchannel(parameter2);
        setChannelProperty(channelList[3]);
        setAllChannel(true);
      }else{
        navigate("/invalidChannel")
      }
      
    }
    channelTheme();
    if (parameter2 && !parameter1) {
      if (parameter2 === "HSBC") {
        if(parameter3){
          setIsRedirected(false)
          setIsNavigateToRM(false)
        }else{
          setIsRedirected(false)
          setIsNavigateToRM(true)
        }
      } else {
        setIsRedirected(false)
        setIsNavigateToRM(false)
      }
    } else {
      if (parameter1 && parameter2) {
        setIsNavigateToRM(false);
        getIpAddress()
          .then(async res => {
            let payload = {
              ip: res.IPv4
            }
            if (refreshToken) {
              const payload = {
                data: parameter1,
                source: parameter2,
              }
              try {
                const res = await decryptUrl(payload)
                console.log(res)
                setDecryptData(res.data)
              } catch (err) {
                setIsRedirected(false)
                console.log(err)
              }
            } else {
              getJWTTokenForIp(payload)
                .then(async res => {
                  const payload = {
                    data: parameter1,
                    source: parameter2,
                  }
                  try {
                    const res = await decryptUrl(payload)
                    console.log(res)
                    if(res?.data?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.uid){
                      setJourneyState(prev => ({
                        ...prev,
                        uid: res?.data?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.uid || ""
                      }))
                    }
                    // check if utmparams are there then set that in setJourneyState
                    if(res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_source || res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_medium || res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_campaign || res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_term || res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_content || res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_cohort){
                      setJourneyState(prev => ({
                        ...prev,
                        utmParams: {
                          utm_source: res?.data?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_source || "",
                          utm_medium: res?.data?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_medium || "",
                          utm_campaign: res?.data?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_campaign || "",
                          utm_term: res?.data?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_term || "",
                          utm_content: res?.data?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_content || "",
                          utm_cohort: res?.data?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_cohort || "",
                        }
                      }))
                    }
                    setDecryptData(res.data)
                  } catch (err) {
                    setIsRedirected(false)
                    console.log(err)
                  }
                })
            }
          })

      }
    }
  }
  function channelTheme() {
    if (channel && channelProperty && channelProperty.csskeyvalue) {
      const cssArr = channelProperty.csskeyvalue;
      cssArr.forEach(element => {
        document.documentElement.style.setProperty(
          element.cssKey,
          element.cssValue
        )
      });
      if(channel == "hsbc" || channel == "canara" || channel == "pnb" || ["EQUITAS", "equitas", "36"].includes(channel)){
        document.documentElement.style.setProperty("--lumiq-img-url",`url(${withPrefix(`/images/icon-${channel.toLocaleLowerCase()}.png`)})`)
        document.documentElement.style.setProperty("--lumiq-checkbox",`url(${withPrefix(`/images/chek-box-${channel.toLocaleLowerCase()}.png`)})`);
      }else{
        document.documentElement.style.setProperty("--lumiq-img-url",`url(${withPrefix('/images/icon-others.png')})`)
        document.documentElement.style.setProperty("--lumiq-checkbox",`url(${withPrefix('/images/chek-box-others.png')})`);
      }
    }
    else {
      // Fallback theme: align with Canara palette instead of HSBC
      document.documentElement.style.setProperty("--lumiq-primary", "#0088c3")
      document.documentElement.style.setProperty("--lumiq-secondary", "#0ab0ef")
      document.documentElement.style.setProperty("--lumiq-tertiary", "#fec32b")
      document.documentElement.style.setProperty("--lumiq-header", "#fec32b")
      document.documentElement.style.setProperty("--lumiq-secondary2", "#fec32b")
      document.documentElement.style.setProperty("--lumiq-hover", "#0ab0ef")
      document.documentElement.style.setProperty("--lumiq-footer-bg", "#eeeeee")
      document.documentElement.style.setProperty("--lumiq-footer-color", "#848181")
      document.documentElement.style.setProperty("--lumiq-footer-icon-color", "#c4c4c4")
      document.documentElement.style.setProperty("--lumiq-footer-bg2", "none")
      document.documentElement.style.setProperty("--lumiq-footer-border", "1px solid #848181")
      document.documentElement.style.setProperty("--lumiq-footer-shadow", "none")
      document.documentElement.style.setProperty("--lumiq-footer-bold", "100")
      document.documentElement.style.setProperty("--lumiq-bg", "#fff")
      document.documentElement.style.setProperty("--lumiq-card-bg", "#0ab0ef")
      document.documentElement.style.setProperty("--lumiq-img-url", `url(${withPrefix('/images/icon-canara.png')})`);
      document.documentElement.style.setProperty("--lumiq-checkbox",`url(${withPrefix('/images/chek-box-canara.png')})`);
      document.documentElement.style.setProperty("--lumiq-error", "#ff0000");
      document.documentElement.style.setProperty("--image-color", "#0ab0ef");
    }

  }

  useEffect(() => {
    channelTheme()
  }, [channel, channelProperty])

  const isJourneyStart = (rmData)=> {
    setIsNavigateToRM(false);
    setAllChannel(true);
    setRmData(rmData)
  }
   const aesEncryptData = data => {
    if (typeof window === "undefined") {
      return
    }
    else
    return  CryptoJS.AES.encrypt(JSON.stringify(data), `${process.env.DECRYPT_KEY}`).toString();
  }
  return (
    <>
    <Beforeunload onBeforeunload={async (event) => {
    clearAllCookies();
    let journeyId = journeyId || journeyState.journeyId || "3221"
    if(journeyId !== "3221"){
    let payload ={
      journeyId: journeyId
    }
    let encryptData = aesEncryptData(payload)
    console.log("datae", encryptData);
    let encryptedPayload = {
    encryptData: encryptData
  }
    const apiUrl = process.env.GATASBY_API_URL
    let res = await axios.post(`${apiUrl}/save-dropout-timestamp`, encryptedPayload)
    console.log(res)
}
      // .then(res => {
      //   console.log(res)
      // })
      // .catch(error => {
      //   console.log(error)
      // })
  }}>
      {console.log("journey details",isRedirected, isNavigateToRM, props.resumeJourneyData, journeyId)}
      <Header />
        {
          isRedirected ? 
        (
          decryptData && (
            <JourneyOne
              resumeJourneyData={props.resumeJourneyData}
              decryptData={decryptData}
              channel ={channel}
            />
          )
        ) : 
        isNavigateToRM && channel === "hsbc"
          ? (<Rmled isJourneyStart={isJourneyStart} channel= {channel} location = {props.location}/>)
          : Object.keys(rmData).length > 0
          ? (<JourneyOne rmData={rmData}/>) 
          : props.resumeJourneyData
          ? (<JourneyOne resumeJourneyData={props.resumeJourneyData}/>) 
          : journeyId 
          ? (<JourneyOne journeyId={journeyId}/>) 
          : props.paymentData && props.paymentData.payloadJson && props.paymentData.decryptData
          ? (<JourneyOne paymentData={props.paymentData} />) 
          : props.digilockerdata && props.digilockerdata.digilockerDecryptData && props.digilockerdata.digilockerPayloadJson
          ? (<JourneyOne digilockerdata={props.digilockerdata} />) 
          : props.enachData && props.enachData.enachDecryptData && props.enachData.enachPayloadJson
          ? (<JourneyOne enachData={props.enachData} />)
          : props.lienData && props.lienData.lienDecryptData && props.lienData.lienPayloadJson
          ? (<JourneyOne lienData={props.lienData} />)
          : props.canaraPosData
          ? (<JourneyOne canaraPosData={props.canaraPosData} />) 
          : props.fnaData
          ? (<JourneyOne fnaData={props.fnaData} />)
          :allChannel ? (<JourneyOne channel={channel}/>):(<></>)
        }
      <Footer />
      <OfflineNotice />
      </Beforeunload>
    </>
  )
}

export default Layout
